import { CommonModule, registerLocaleData } from '@angular/common'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import localePt from '@angular/common/locales/pt'
import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core'
import { MatMomentDateModule, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'
import { RouterModule } from '@angular/router'
import { AlertModule } from '../alert/alert/alert.module'
import { LayoutModule } from '../layout/layout.module'
import { HttpInterceptorService } from './interceptor/http-interceptor.service'
import { UserContextService } from './service/user-context.service'

registerLocaleData(localePt)

export const DATE_FORMAT = {
  parse: {
    dateInput: ['DD/MM/YYYY'],
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@NgModule({
  imports: [CommonModule, LayoutModule, RouterModule, HttpClientModule, AlertModule, MatMomentDateModule],
  exports: [CommonModule, LayoutModule, RouterModule, HttpClientModule, AlertModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [UserContextService],
      useFactory: (userContext: UserContextService) => userContext.init(),
    },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_MOMENT_DATE_FORMATS, useValue: DATE_FORMAT },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
  ],
})
export class CoreModule {}
